import { dashboardConstants } from "../../constants/client";

export const dashboard = {
  listing,
  listingSuccess,
  listingFailure,
};

function listing(payload) {
  return {
    type: dashboardConstants.LISTING_REQUEST,
    payload
  };
}

function listingSuccess(payload) {
  return { type: dashboardConstants.LISTING_SUCCESS, payload };
}

function listingFailure(error) {
  return { type: dashboardConstants.LISTING_FAILURE, error };
}